import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { Box } from '@mui/material'
import PageWrapper from 'Pages/@PageWrapper'
import { GROUPING_EXPORTS_ROUTES, REPORT_ROUTES } from '@constants/routes'
import GroupingExportsContent from 'Pages/ReportsAlerts/ExportsGrouping/Content'
import VirtualTourButton, { TourOverlay, TOUR_STEPS } from './VirtualTour'
import GroupingExportsDemoData from './VirtualTour/DemoData'
import { isTourDemoActive } from '@signals/app'
import { groupingExecutionType } from './@signals'


export default function GroupingExportsPage({ executionType = 'execution', title = 'Reports', subtitle = REPORT_ROUTES.GROUPING_TITLE }) {
	const [tourActive, setTourActive] = useState(false)

	// the same page serves the grouped exports and the grouped One Way workbooks; the hooks read the type from the signal
	useEffect(() => {
		groupingExecutionType.value = executionType
		return () => { groupingExecutionType.value = 'execution' }
	}, [ executionType ])

	return <PageWrapper
		head={`DS Rentacar | ${subtitle}`}
		title={title}
		subtitle={subtitle}
		isEmpty={false}
		actions={<VirtualTourButton onClick={() => { setTourActive(true); isTourDemoActive.value = true }} />}
	>
		<GroupingExportsContent/>
		{tourActive && !document.querySelector('.MuiTable-root tbody tr') && <GroupingExportsDemoData/>}
		{tourActive && createPortal(
			<TourOverlay steps={TOUR_STEPS} onClose={() => { setTourActive(false); isTourDemoActive.value = false }} />,
			document.body
		)}
	</PageWrapper>
}